import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Events from "./pages/Events/Events";
import Contact from "./pages/Contact/Contact";
import Donate from "./pages/Donate/Donate";
import President from "./pages/President/President";
import ActivityDetail from "./pages/ActivityDetail/ActivityDetail";
import Chatbot from "./components/Chatbot/Chatbot";
import AdModal from "./components/AdModal/AdModal";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/event" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/president" element={<President />} />
        <Route path="/activity/:id" element={<ActivityDetail />} />
        <Route path="*" element={<Navigate to={"/"} />} />
      </Routes>
      <Chatbot />
      <AdModal />
    </BrowserRouter>
  );
}
